import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';

import MenuComponent2 from './MenuComponent2';
import ShippingCalendar from './ShippingCalendar';
import ImageUploader from './ImageUploader';
import CountryMappngList from './CountryMappngList';
import AuthenticationService from '../services/AuthenticationService';
import couterpart from 'counterpart';
import MasterDataService from '../services/MasterDataService';
import { MdDeleteForever, MdModeEdit } from 'react-icons/md';
import { ICON_COLOR } from '../icon';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Dialog from 'react-bootstrap-dialog';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import { Multiselect } from 'multiselect-react-dropdown';
import { FaRegSave } from 'react-icons/fa';

class Settings extends Component {
    constructor() {
        super();
        this.state = {
            shippingCalendars: [],
            columns: [
                {
                    id: "idx",
                    accessor: "",
                    width: 40,
                    Cell: row => (
                        <div style={{ padding: "10px" }}>{row.index + 1}</div>
                    )
                },
                {
                    Header: couterpart.translate('settings_calendar'),
                    accessor: 'calendar',
                    width: 600,
                    Cell: row => (
                        this.mapToNgay(row.original.calendar)
                    )
                }, {
                    Header: couterpart.translate('settings_duration'),
                    accessor: 'duration',
                    width: 70
                }, {
                    Header: couterpart.translate('settings_shipTo'),
                    accessor: 'shipTo',
                    width: 120
                }, {
                    Header: couterpart.translate('action'),
                    accessor: 'action',
                    Cell: row => (
                        this.getFunctionButtons(row)
                    )
                }
            ],
            showEdit: false,
            id: 0,
            calendar: '1,4',
            duration: 7,
            shipTo: '',
            selectedDays: [
                { id: 1, name: 'Thứ ba' },
                { id: 4, name: 'Thứ sáu' },
            ],
            days: [
                { id: 0, name: 'Thứ hai' },
                { id: 1, name: 'Thứ ba' },
                { id: 2, name: 'Thứ tư' },
                { id: 3, name: 'Thứ năm' },
                { id: 4, name: 'Thứ sáu' },
                { id: 5, name: 'Thứ bảy' },
                { id: 6, name: 'Chủ nhật' },
            ],
            printConfigColumns: [
                {
                    id: "idx",
                    accessor: "",
                    width: 40,
                    Cell: row => (
                        <div style={{ padding: "10px" }}>{row.index + 1}</div>
                    )
                },
                {
                    Header: couterpart.translate('settings_pc_code'),
                    accessor: 'code',
                    width: 500
                },
                {
                    Header: couterpart.translate('settings_pc_document_file'),
                    accessor: 'documentFile',
                    width: 500
                }, {
                    Header: couterpart.translate('settings_pc_print_to_file_name'),
                    accessor: 'printToFileFileName',
                    width: 200
                }, {
                    Header: couterpart.translate('settings_pc_print_to_file_folder'),
                    accessor: 'printToFileFolder',
                    width: 200
                }, {
                    Header: couterpart.translate('settings_pc_printer'),
                    accessor: 'printer',
                    width: 120
                }, {
                    Header: couterpart.translate('settings_pc_username'),
                    accessor: 'username',
                    width: 120
                }, {
                    Header: couterpart.translate('settings_pc_save_after_print'),
                    accessor: 'saveAfterPrint',
                    width: 120,
                    Cell: row => (
                        this.isSave(row.original.saveAfterPrint)
                    )
                }, {
                    Header: couterpart.translate('settings_pc_url'),
                    accessor: 'url',
                    width: 450
                }, {
                    Header: couterpart.translate('action'),
                    accessor: 'action',
                    Cell: row => (
                        this.getFunctionButtonsPc(row)
                    )
                }
            ],
            showEditPc: false,
            printConfigs: []
        };
    };

    componentDidMount() {
        this.loadShippingCalendars();
        this.loadPrintConfigs();
    }

    getFunctionButtons(row) {
        if (AuthenticationService.isAdmin() || AuthenticationService.isService()) {
            const button_edit = couterpart.translate('button_edit');
            const button_delete = couterpart.translate('button_delete');
            return (
                <div style={{ textAlign: "center" }}>
                    <button className="myButton" onClick={() => this.handleEdit(row.original)}>
                        <MdDeleteForever color={ICON_COLOR} />&nbsp;
                        {button_edit}</button>&nbsp;
                    {/* <button className="myButton" onClick={() => this.handleDelete(row.original)}>
            <MdModeEdit color={ICON_COLOR}/>&nbsp;
            {button_delete}</button> */}
                </div>
            )
        } else {
            return (<div>&nbsp;</div>)
        }
    }

    getFunctionButtonsPc(row) {
        if (AuthenticationService.isAdmin() || AuthenticationService.isService()) {
            const button_edit = couterpart.translate('button_edit');
            return (
                <div style={{ textAlign: "center" }}>
                    <button className="myButton" onClick={() => this.handleEditPc(row.original)}>
                        <MdDeleteForever color={ICON_COLOR} />&nbsp;
                        {button_edit}</button>&nbsp;
                </div>
            )
        } else {
            return (<div>&nbsp;</div>)
        }
    }

    handleEdit(row) {
        console.log(row)
        this.setState({
            showEdit: true,
            id: row.id,
            calendar: row.calendar,
            duration: row.duration,
            shipTo: row.shipTo
        });
    }

    handleEditPc(row) {
        console.log(row)
        this.setState({
            showEditPc: true,
            id: row.id,
            code: row.code,
            documentFile: row.documentFile,
            printToFileFileName: row.printToFileFileName,
            printToFileFolder: row.printToFileFolder,
            printer: row.printer,
            username: row.username,
            pwd: row.pwd,
            url: row.url,
            saveAfterPrint: row.saveAfterPrint
        });
    }

    handleDelete(e) {
        // ItemDataService.deleteItemMapping(e.id).then(data => {
        //   if (data.message === undefined){
        //     if (AuthenticationService.isAdmin()){
        //       ItemDataService.retrieveItemMappingsBy('').then(data => {
        //         this.setState({ itemmappings:  data})
        //       });
        //     } else {
        //       ItemDataService.retrieveItemMappingsByShopAndBy('').then(data => {
        //         this.setState({ itemmappings:  data})
        //       });
        //     }
        //   }
        // });
    }

    mapToNgay(shipCalendar) {
        let ngayShips = shipCalendar.split(",");
        if (ngayShips == null) {
            return "";
        }

        ngayShips.sort();

        let ret = "";
        let sep = "";
        for (let i = 0; i < ngayShips.length; i++) {
            let iday = parseInt(ngayShips[i]);
            let sday = this.dayToNgay(iday);
            ret = ret + sep + sday;
            sep = ", ";
        }
        return ret;
    }

    isSave(vl) {
        return vl === true? 'true' : 'false';
    }

    dayToNgay(iday) {
        if (iday >= 0 && iday <= 6) {
            return this.state.days[iday].name;
        }
        return iday;
    }

    loadShippingCalendars() {
        MasterDataService.retrieveShippingCalendars().then(data => {
            this.setState({
                shippingCalendars: data
            });
        });
    }

    loadPrintConfigs() {
        MasterDataService.fetchPrintConfigs().then(data => {
            this.setState({
                printConfigs: data
            });
        });
    }

    renderShippingCalendars() {
        return (<>
            <ReactTable
                NoDataComponent={() => null}
                previousText={"<"}
                nextText={">"}
                data={this.state.shippingCalendars}
                columns={this.state.columns}
                defaultPageSize={3}
                showPageSizeOptions={true}
                pageSizeOptions={[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => {
                    if (rowInfo && rowInfo.row) {
                        return {
                            onClick: (e) => {
                                this.setState({
                                    selected: rowInfo.index,
                                    itemId: rowInfo.original.id
                                })
                            },
                            style: {
                                background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                                color: rowInfo.index === this.state.selected ? 'white' : 'black'
                            }
                        }
                    } else {
                        return {}
                    }
                }
                }
            />
        </>);
    }

    renderPrintConfigs() {
        return (<>
            <ReactTable
                NoDataComponent={() => null}
                previousText={"<"}
                nextText={">"}
                data={this.state.printConfigs}
                columns={this.state.printConfigColumns}
                defaultPageSize={3}
                showPageSizeOptions={true}
                pageSizeOptions={[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => {
                    if (rowInfo && rowInfo.row) {
                        return {
                            onClick: (e) => {
                                this.setState({
                                    selected: rowInfo.index,
                                    itemId: rowInfo.original.id
                                })
                            },
                            style: {
                                background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                                color: rowInfo.index === this.state.selected ? 'white' : 'black'
                            }
                        }
                    } else {
                        return {}
                    }
                }
                }
            />
        </>);
    }

    handleCloseEdit() {
        this.setState({ showEdit: false },
            () => {
                //this.sleep(500).then(() => {
                //this.scanWorkOrderNo.focus();
                //})
            });
    }

    onEditOKClicked() {
        this.handleSave();
    }

    handleCloseEditPc() {
        this.setState({ showEditPc: false },
            () => {
                //this.sleep(500).then(() => {
                //this.scanWorkOrderNo.focus();
                //})
            });
    }

    onEditOKClickedPc() {
        this.handleSavePc();
    }

    onSelect(selectedList, selectedItem) {
        this.setState({
            selectedDays: selectedList
        });
    }

    onRemove(selectedList, removedItem) {
        this.setState({
            selectedDays: selectedList
        });
    }

    handleChange(e) {
        var name = e.target.name;
        var value = e.target.value;
        this.setState({ [name]: value });
    }

    handleSave() {
        let answ = window.confirm(couterpart.translate('msg_calendar_save_confirm'));
        if (answ) {
            if (this.state.selectedDays === undefined || this.state.selectedDays === null || this.state.selectedDays.length < 1) {
                ToastsStore.error(couterpart.translate('msg_calendar_day_missing'));
                return;
            }

            if (this.state.duration === undefined || this.state.duration === null || this.state.duration < 1) {
                ToastsStore.error(couterpart.translate('msg_calendar_duration_missing'));
                return;
            }

            if (this.state.duration === undefined || this.state.duration === null || this.state.duration < 1) {
                ToastsStore.error(couterpart.translate('msg_calendar_shipTo_missing'));
                return;
            }

            let days = '';
            let sep = '';
            for (let i = 0; i < this.state.selectedDays.length; i++) {
                days += sep + this.state.selectedDays[i].id;
                sep = ',';
            }

            let info = {
                id: this.state.id,
                duration: this.state.duration,
                calendar: days,
                shipTo: this.state.shipTo
            }

            if ((this.state.id != null) && (this.state.id > 0)) {
                MasterDataService.updateShippingCalendar(info).then(data => {
                    ToastsStore.info(couterpart.translate("msg_saved_info"));
                    this.loadShippingCalendars();
                });
                this.setState({ showEdit: false });
            } else {
                ToastsStore.error(couterpart.translate('msg_saved_error'));
            }
        }
    }

    handleSavePc() {
        let answ = window.confirm(couterpart.translate('msg_calendar_save_confirm'));
        if (answ) {
            if (this.state.code === undefined || this.state.code === null || this.state.code.length < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_code_msg'));
                return;
            }

            if (this.state.documentFile === undefined || this.state.documentFile === null || this.state.documentFile.length < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_document_file_msg'));
                return;
            }

            if (this.state.printToFileFileName === undefined || this.state.printToFileFileName === null || this.state.printToFileFileName < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_print_to_file_name_msg'));
                return;
            }

            if (this.state.printToFileFolder === undefined || this.state.printToFileFolder === null || this.state.printToFileFolder < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_print_to_file_folder_msg'));
                return;
            }

            if (this.state.printer === undefined || this.state.printer === null || this.state.printer.length < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_printer_msg'));
                return;
            }

            if (this.state.username === undefined || this.state.username === null || this.state.username.length < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_username_msg'));
                return;
            }

            if (this.state.pwd === undefined || this.state.pwd === null || this.state.pwd.length < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_pwd_msg'));
                return;
            }

            if (this.state.url === undefined || this.state.url === null || this.state.url.length < 1) {
                ToastsStore.error(couterpart.translate('settings_pc_url_msg'));
                return;
            }

            let info = {
                id: this.state.id,
                code: this.state.code,
                documentFile: this.state.documentFile,
                printToFileFileName: this.state.printToFileFileName,
                printToFileFolder: this.state.printToFileFolder,
                printer: this.state.printer,
                username: this.state.username,
                pwd: this.state.pwd,
                url: this.state.url,
                saveAfterPrint: this.state.saveAfterPrint === 1? true : false
            }

            console.log(info);

            if ((this.state.id != null) && (this.state.id > 0)) {
                MasterDataService.updatePrintConfig(info).then(data => {
                    ToastsStore.info(couterpart.translate("msg_saved_info"));
                    this.loadPrintConfigs();
                });
                this.setState({ showEditPc: false });
            } else {
                ToastsStore.error(couterpart.translate('msg_saved_error'));
            }
        }
    }

    handleSaveAfterPrintClick() {
        if (this.state.saveAfterPrint === 1) {
            this.setState({ saveAfterPrint: 0 });
        } else {
            this.setState({ saveAfterPrint: 1 });
        }
    }

    render() {
        if (!AuthenticationService.isAdmin()) {
            return (<div>Unauthorized access.</div>);
        }

        return (
            <div>
                <MenuComponent2 />
                <br />
                <br />
                <div className="row">
                    <div className="col-12">
                        {this.renderShippingCalendars()}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <ImageUploader />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <CountryMappngList />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        &nbsp;
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <b>Print Barcode Config</b>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {this.renderPrintConfigs()}
                    </div>
                </div>
                <Modal show={this.state.showEdit} onHide={this.handleCloseEdit.bind(this)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{couterpart.translate("msg_title_confirm")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-12">
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-2">
                                        {couterpart.translate('shipping_calendar_day')}:
                                    </div>
                                    <div className="col-10">
                                        <Multiselect
                                            options={this.state.days}
                                            selectedValues={this.state.selectedDays}
                                            onSelect={this.onSelect.bind(this)}
                                            onRemove={this.onRemove.bind(this)}
                                            displayValue="name"
                                            showCheckbox={true}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-2">
                                        {couterpart.translate('shipping_calendar_duration')}:
                                    </div>
                                    <div className="col-10">
                                        <input name="duration" type="number" size="40"
                                            placeholder="" value={this.state.duration}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-2">
                                        {couterpart.translate('shipping_calendar_shipTo')}:
                                    </div>
                                    <div className="col-10">
                                        <input name="shipTo" size="40"
                                            placeholder="" value={this.state.shipTo}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleCloseEdit.bind(this)}>Cancel</Button>
                        <Button variant="primary" onClick={this.onEditOKClicked.bind(this)}>OK</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showEditPc} onHide={this.handleCloseEditPc.bind(this)} backdrop="static" dialogClassName="modal-40w">
                    <Modal.Header closeButton>
                        <Modal.Title>{couterpart.translate("msg_title_confirm")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-12">
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_code')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="code" size="40"
                                            placeholder="" value={this.state.code}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_document_file')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="documentFile" size="40"
                                            placeholder="" value={this.state.documentFile}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_print_to_file_name')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="printToFileFileName" size="40"
                                            placeholder="" value={this.state.printToFileFileName}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_print_to_file_folder')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="printToFileFolder" size="40"
                                            placeholder="" value={this.state.printToFileFolder}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_printer')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="printer" size="40"
                                            placeholder="" value={this.state.printer}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_username')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="username" size="40"
                                            placeholder="" value={this.state.username}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_pwd')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="pwd" size="40" type="password"
                                            placeholder="" value={this.state.pwd}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_save_after_print')}:
                                    </div>
                                    <div className="col-8">
                                        <label><input type="checkbox" value="1" onChange={this.handleSaveAfterPrintClick.bind(this)} checked={this.state.saveAfterPrint == 1 ? true : false} /> {couterpart.translate('settings_pc_save_after_print')} </label>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: "5px" }}>
                                    <div className="col-4">
                                        {couterpart.translate('settings_pc_url')}:
                                    </div>
                                    <div className="col-8">
                                        <input name="url" size="40"
                                            placeholder="" value={this.state.url}
                                            onChange={this.handleChange.bind(this)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleCloseEditPc.bind(this)}>Cancel</Button>
                        <Button variant="primary" onClick={this.onEditOKClickedPc.bind(this)}>OK</Button>
                    </Modal.Footer>
                </Modal>

                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <Dialog ref={(component) => { this.dialog = component }} />
            </div>

        );
    }
}

export default Settings;
